import { useState } from "react";
import {
  Card,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import { Add as AddIcon, Close as CloseIcon } from "@mui/icons-material";
import "./HorizontalMenu.scss";
import content from "../data/content.json";

// Import background images
const f1Bg = require("../assets/f1-bg.jpg");
const starshipBg = require("../assets/starship-bg.jpg");
const movieBg = require("../assets/movies-bg.jpg");
const musicBg = require("../assets/music-bg.jpeg");
const astroBg = require("../assets/astro-bg.jpg");
const xkcdBg = require("../assets/xkcd-bg.jpg");
const photographyBg = require("../assets/photography-bg.jpg");

const HorizontalMenu = ({
  items = [],
  className = "",
  variant = "default",
}) => {
  const [open, setOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const handleOpenModal = (item) => {
    setSelectedItem(item);
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
    setSelectedItem(null);
  };

  // Function to get background image based on title
  const getBackgroundImage = (title) => {
    const imageMap = {
      "Formula 1": f1Bg,
      "Engineering": starshipBg,
      "Astrophysics": astroBg,
      "Movies": movieBg,
      "Music": musicBg,
      "Photography": photographyBg,
      "XKCD Comics": xkcdBg,
    };
    return imageMap[title] || null;
  };

  return (
    <div
      className={`horizontal-menu-wrapper ${className} d-flex align-items-center gap-3 my-3`.trim()}
    >
      <nav
        className="horizontal-menu overflow-auto p-2"
        role="navigation"
        aria-label="About me menu"
      >
        <div className="items-track d-flex gap-3 align-items-center">
          {items && items.length > 0
            ? items.map((item, i) => {
                const bgImage = getBackgroundImage(item);
                const style = bgImage
                  ? {
                      backgroundImage: `url(${bgImage})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      color: "white",
                    }
                  : {};
                return (
                  <Card
                    key={item}
                    className={"menu-item menu-card " + variant}
                    style={style}
                  >
                    <div className="card-content">
                      {item}
                      {variant === "personal" && (
                        <IconButton
                          className="add-icon"
                          onClick={() => handleOpenModal(item)}
                          size="small"
                        >
                          <AddIcon />
                        </IconButton>
                      )}
                    </div>
                  </Card>
                );
              })
            : null}
        </div>
      </nav>
      <Dialog open={open} onClose={handleCloseModal} maxWidth="md" fullWidth>
        <DialogTitle>
          {selectedItem}
          <IconButton
            onClick={handleCloseModal}
            style={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <p
            dangerouslySetInnerHTML={{
              __html: content.personalDescriptions[selectedItem],
            }}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default HorizontalMenu;
